import { useTranslation } from 'react-i18next'
import Checkbox from './ui/Checkbox'

interface AcceptPolicyProps {
  isPolicyAccepted: boolean
  privacyUrl: string
  setIsPolicyAccepted: (accepted: boolean) => void
}

const AcceptPolicy = ({ isPolicyAccepted, setIsPolicyAccepted, privacyUrl }: AcceptPolicyProps) => {
  const { t } = useTranslation()

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsPolicyAccepted(e.target.checked)
  }

  return (
    <div className="flex justify-center text-center px-4 text-sm dark:text-zinc-400">
      <Checkbox
        id="wp-policy-acceptance"
        onChange={handleCheckboxChange}
        checked={isPolicyAccepted}
        text={
          <span className="whitespace-normal text-left">
            {t('policy.leading', 'I have read the')}{' '}
            <a className="underline text-[#bbb]" href={privacyUrl} target="_blank">
              {t('policy.link', 'terms and privacy policy')}
            </a>
          </span>
        }
      />
    </div>
  )
}

export default AcceptPolicy
